// GO富集气泡图
import ChartTemplate from '../ChartTemplate';
import $ from '@/assets/jquery/jquery-vendor.js';
export default {
  extends: ChartTemplate,
  props: {
    config: {
      default: function () { return { group: 3, name: 2, x: 12, y: 2, z: 5, topX: 20 } }
    }
  },
  data () {
    return {
      extCPT: () => import('./ExtendComponent.vue')
    }
  },
  computed: {
    extCPTProps () {
      return { dataSourceParam: this.dataSourceParam, dataSource: this.dataSource }
    }
  },
  methods: {
    async initDataAfter () {
      await require('highcharts/modules/heatmap')(this.Highcharts);
      (function (H) {
        var bubbleProto = H.seriesTypes.bubble.prototype;
        bubbleProto.axisTypes = ['xAxis', 'yAxis', 'colorAxis'];
        bubbleProto.optionalAxis = 'colorAxis';
        bubbleProto.colorKey = 'colorValue';
        bubbleProto.pointArrayMap = ['y', 'z', 'colorValue'];
        bubbleProto.parallelArrays = ['x', 'y', 'z', 'colorValue'];
        H.wrap(bubbleProto, 'translate', function (proceed) {
          proceed.apply(this, Array.prototype.slice.call(arguments, 1));
          H.seriesTypes.heatmap.prototype.translateColors.call(this);
        });
      })(this.Highcharts);
    },

    initOption () {
      let bubbleOption = this.getBubbleOption();
      let dataOption = this.getDataOption();
      this.Utility.deepMerge(this.chartOption, bubbleOption, dataOption, this.paramOption);
    },
    initChartAfter () {
      this.hideNumberCategory();
    },



    hideNumberCategory () {
      let yAxisTexts = $(`#${this.chartElId} .highcharts-yaxis-labels`).children();
      yAxisTexts.each(function () {
        let t = $(this).text();
        if (parseInt(t) == t) $(this).hide();
      })
    },
    // =============== 获取气泡图基础option
    getBubbleOption () {
      return {
        chart: { animation: false },
        credits: { enabled: false },
        title: { text: '' },

        yAxis: {
          title: { text: null }, gridLineWidth: 0,
          tickWidth: 1,
          tickmarkPlacement: 'on',
          tickColor: '#00000066', tickLength: 5, lineWidth: 1, lineColor: '#00000066',
          labels: { step: 1, style: { textOverflow: 'none', whiteSpace: 'nowrap' } }
        },
        xAxis: {
          tickColor: '#00000066', tickLength: 5, tickWidth: 1, lineWidth: 1, lineColor: '#00000066'
        },
        colorAxis: {
          minColor: '#00FF00', maxColor: '#FF0000',
          //  min: 0, max: 1 
        },
        plotOptions: {
          bubble: {
            maxSize: '10%'
          },
          series: { stickyTracking: false, turboThreshold: 0 }
        }
      }
    },
    // ================ 获取GO富集的数据option
    getDataOption (srs) {
      let pValueCol = 8;
      let
        p1 = this.config.title == false ? false : true,
        p2 = this.config.group == null ? 0 : this.config.group,
        p3 = this.config.name == null ? 1 : this.config.name,
        p4 = this.config.x == null ? 2 : this.config.x,
        //p5 = this.config.y == null ? 3 : this.config.y,
        p6 = this.config.z == null ? 4 : this.config.z,
        p7 = this.config.topX;
      let rows;
      if (srs) rows = srs;
      else {
        rows = p1 ? this.dataSource.slice(1) : this.dataSource;
        if (p7) rows = rows.slice(0, p7);
      }

      let ss = [], cts = [], markers = { 'BP': 'circle', 'MF': 'diamond', 'CC': 'triangle' }; //, markers = ['circle', 'diamond', 'triangle', 'triangle-down','square'], markerIndex = 0;
      for (let i = 0, l = rows.length; i < l; i++) {
        let r = rows[i];
        let sd;
        if (p2 != -1) sd = ss.find(t => t.name == r[p2]);
        else sd = ss[0];
        cts.push(r[p3]);
        let sdr = { x: Number(r[p4]), y: i, z: Number(r[p6]), colorValue: Number(r[pValueCol]), _sn: i, pValue: r[pValueCol] };
        if (p3 != -1) sdr.name = r[p3];
        if (sd) {
          sd.data.push(sdr);
        } else {
          sd = { marker: { symbol: markers[r[p2]] || 'circle' }, data: [sdr] };
          if (p2 != -1) sd.name = r[p2];
          ss.push(sd);
        }
      }
      return {
        chart: { type: 'bubble' },
        tooltip: { headerFormat: '', pointFormat: ' {point.z}' }, // {point.pValue:.2f},
        plotOptions: { series: { dataLabels: { format: '{key}', crop: false, allowOverlap: true, overflow: 'none' } } },
        yAxis: { categories: cts },
        series: ss
      }
    },


    // 扩展组件的表格行勾选事件
    onExtCPTChanged (srs) {
      let option = this.getDataOption(srs);
      // this.Utility.deepMerge(this.chartOption, option);
      this.chartOption.series = option.series;
      this.chartOption.yAxis.categories = option.yAxis.categories;
      this.chart.destroy();
      this.chart = this.Highcharts.chart(this.chartElId, this.chartOption);
      this.hideNumberCategory();
      // console.log(JSON.stringify(option));
      // this.chart.update(option);
    }
  }
}